/**
 * Canvas — renders the active view from the server.
 *
 * State shape: { views: Array<{ id, name, data }> } — simple stack; v1
 * just renders the last pushed view. Future extensions could support
 * named slots (main/sidebar/detail) for multi-panel layouts.
 */

import React from "react";
import { getViewComponent } from "./registry.jsx";

export default function Canvas({ views = [], onAction }) {
  // v1: single-slot — render the most recent view. Earlier views are
  // kept in state so "clear the top one and fall back" works if we
  // add layering later. For now we just render the newest.
  const topView = views[views.length - 1];

  if (!topView) {
    return (
      <div style={{ textAlign: "center", padding: "80px 20px", color: "#999" }}>
        <div style={{ fontSize: 42, marginBottom: 16 }}>○</div>
        <p style={{ margin: 0 }}>Waiting for the agent to show a view…</p>
        <p className="muted small" style={{ marginTop: 8 }}>
          Start a session above to begin.
        </p>
      </div>
    );
  }

  const Component = getViewComponent(topView.name);
  if (!Component) {
    return (
      <div style={{ padding: 20, background: "#fff3e0", border: "1px solid #ffb74d", borderRadius: 4, margin: 20 }}>
        <strong>Unknown view:</strong> <code>{topView.name}</code>
        <div className="muted small" style={{ marginTop: 4 }}>
          Register it in client/src/workspace/registry.jsx to render.
        </div>
      </div>
    );
  }

  return <Component data={topView.data || {}} onAction={onAction} />;
}
